import { createContext, useContext, } from 'react';
export const SessionContext = createContext({});
export const useSessionContext = () => {
    return useContext(SessionContext);
};
